import { abandonedCheckoutEmailTemplate } from "@/components/email/template/abandoned-checkout.template";
import { customerPromotionCodeEmailTemplate } from "@/components/email/template/customer-promotion-code.template";
import { subscriptionRebillIncomingEmailTemplate } from "./subscription-rebill-upcoming.template";
import { clubMembershipDeactivatedEmailTemplate } from "./club-membership-deactivated.template";
import { clubMembershipStartedEmailTemplate } from "./club-membership-started.template";
import { orderPaidEmailTemplate } from "./order-paid.template";
import { orderPendingEmailTemplate } from "./order-pending.template";
import { orderRefundedEmailTemplate } from "./order-refunded.template";
import { subscriptionCanceledEmailTemplate } from "./subscription-canceled.template";
import { subscriptionRebillSucceededEmailTemplate } from "./subscription-rebill-succeeded.template";
import { subscriptionPastDueEmailTemplate } from "./subscription-past-due.template";

export const templateRegistry = {
    abandoned_checkout: abandonedCheckoutEmailTemplate,
    order_paid: orderPaidEmailTemplate,
    order_pending: orderPendingEmailTemplate,
    order_refunded: orderRefundedEmailTemplate,
    customer_promotion_code: customerPromotionCodeEmailTemplate,
    subscription_rebill_upcoming: subscriptionRebillIncomingEmailTemplate,
    subscription_rebill_succeeded: subscriptionRebillSucceededEmailTemplate,
    subscription_canceled: subscriptionCanceledEmailTemplate,
    subscription_past_due: subscriptionPastDueEmailTemplate,
    club_membership_started: clubMembershipStartedEmailTemplate,
    club_membership_deactivated: clubMembershipDeactivatedEmailTemplate,
};

export const getDefaultTemplate = (type: TemplateType) => {
    if (!type) {
        return {
            name: '',
            subject: {
                en: '',
                fr: '',
                it: '',
                es: '',
                de: '',
            },
            templateVariables: {},
        };
    }
    return templateRegistry[type]?.defaultTemplate || {};
};



export type TemplateType = keyof typeof templateRegistry;
